import { Box } from '@mui/material';
import React from 'react';

import { roundImageStyle } from '../../utils/utils';

interface Base64AvatarProps {
    src: string;
    style?: React.CSSProperties;
}

export const Base64Avatar: React.FC<Base64AvatarProps> = ({ src, style }) => (
    <Box
        sx={{
            ...roundImageStyle,
            backgroundImage: `url(data:image/png;base64,${src})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
        }}
        style={style}
    />
);
